import Vue from 'vue'

Vue.mixin({
    methods: {
        geteRelativeUrl() {
            // if (Vue.config.devtools) return `http://127.0.0.1:3000/api/`
            return "https://app.motanamy.com/api/"
        }
    }
})

export default {
    scrollBehavior(to, from, savedPosition) {
        return {
            selector: to.hash,
        };
    }
};
